(function () {
    'use strict';

    new Blazy();

    $.extend(true, $.magnificPopup.defaults, {
        tClose: 'Fechar',
        tLoading: 'Carregar...',
        gallery: {
            tPrev: 'Anterior',
            tNext: 'Seguinte',
            tCounter: '%curr% de %total%'
        },
        image: {
            tError: '<a href="%url%">A imagem</a> não pode ser carregada.'
        },
        ajax: {
            tError: '<a href="%url%">O conteúdo</a> não pode ser carregado.'
        }
    });

    $('.slideshow').slick({
        prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Anterior</span></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Seguinte</span></button>',
        dots: true,
        slide: '.slideshow__slide',
        appendArrows: '.slideshow__arrows'
    });

    $('.photo-gallery').each(function () {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            autoFocusLast: false,
            gallery: {
                enabled: true
            }
        });
    });

    $('.video-gallery').each(function () {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            autoFocusLast: false,
            gallery: {
                enabled: true
            }
        });
    });
})();



// WEBPACK FOOTER //
// ./resources/assets/js/main.js